import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import {
  getPendingTeamMembersApi,
  getActiveTeamMembersApi,
  getInActiveTeamMembersApi,
  addTeamMembersApi,
  updateTeamMembersApi,
} from "../../API/API";

function* getPendingTeamMembersSaga(params) {
  try {
    const response = yield call(() => getPendingTeamMembersApi(params));
    yield put({
      type: types.GET_PENDING_TEAM_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({ type: types.GET_PENDING_TEAM_FAILURE, error });
  }
}

function* getActiveTeamMembersSaga(params) {
  try {
    const response = yield call(() => getActiveTeamMembersApi(params));
    yield put({
      type: types.GET_ACTIVE_TEAM_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({ type: types.GET_ACTIVE_TEAM_FAILURE, error });
  }
}

function* getInActiveTeamMembersSaga(params) {
  try {
    const response = yield call(() => getInActiveTeamMembersApi(params));
    yield put({
      type: types.GET_INACTIVE_TEAM_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({ type: types.GET_INACTIVE_TEAM_FAILURE, error });
  }
}

export function* watchGetPendingTeamMembersSaga() {
  yield takeEvery(types.GET_PENDING_TEAM_REQUESTED, getPendingTeamMembersSaga);
}

export function* watchGetActiveTeamMembersSaga() {
  yield takeEvery(types.GET_ACTIVE_TEAM_REQUESTED, getActiveTeamMembersSaga);
}

export function* watchGetInActiveTeamMembersSaga() {
  yield takeEvery(types.GET_INACTIVE_TEAM_REQUESTED, getInActiveTeamMembersSaga);
}

function* addTeamMembersSaga(params) {
  try {
    const response = yield call(() => addTeamMembersApi(params.params));

    yield put({
      type: types.ADD_TEAM_SUCCESS,
      payload: response.data,
    });

  } catch (error) {

    yield put({ type: types.ADD_TEAM_FAILURE, payload: error.response.data });
  }
}

export function* watchAddTeamMembersSaga() {
  yield takeEvery(types.ADD_TEAM_REQUESTED, addTeamMembersSaga);
}

function* updateTeamMembersSaga(action) {
  try {
    const response = yield call(updateTeamMembersApi(action.inv_id, action.params)
    );
    yield put({
      type: types.UPDATE_TEAM_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({ type: types.UPDATE_TEAM_FAILURE, error });
  }
}

export function* watchUpdateTeamMembersSaga() {
  yield takeEvery(types.UPDATE_TEAM_REQUESTED, updateTeamMembersSaga);
}
